import { Injectable } from '@angular/core';

import { DataService } from './data.service';

@Injectable({
    providedIn: 'root',
})
export class WorldPayFetchSessionIdService {
    worldPaySessionId: string;
    worldPaySessionIdStatus: boolean;
    baseWorldPayURLForDDC: string;

    constructor(private dataService: DataService) {}

    async fetchWPSessionId(baseWorldPayURLForDDC: any, worldPayTokenForDDC: any, worldPayURLForDDC: any, card: any) {
        this.baseWorldPayURLForDDC = baseWorldPayURLForDDC;
        if (worldPayURLForDDC && worldPayTokenForDDC) {
            if (window.addEventListener) {
                await window.addEventListener('message', this.setWorldPaySessionId.bind(this), false);
            } else {
                await (<any>window).attachEvent('onmessage', this.setWorldPaySessionId.bind(this));
            }

            const innerHtml =
                '<body onload="document.collectionForm.submit();">' +
                '<form id="collectionForm" name="collectionForm" action="' +
                worldPayURLForDDC +
                '" method="POST">' +
                '<input type="hidden" name="Bin" value="' +
                card +
                '" />' +
                '<input type="hidden" name="JWT" value="' +
                worldPayTokenForDDC +
                '" />' +
                '</form>' +
                '</body>';
            const iframe = document.createElement('iframe');
            iframe.width = '0';
            iframe.height = '0';
            iframe.style.visibility = 'hidden';
            iframe.style.display = 'none';
            iframe.srcdoc = innerHtml;

            document.body.appendChild(iframe);
        }
    }

    setWorldPaySessionId(event: any) {
        if (event.origin === this.baseWorldPayURLForDDC) {
            const data = event?.data && typeof event.data == 'string' && JSON.parse(event?.data);
            if (data && data.Status) {
                this.worldPaySessionId = data.SessionId;
                this.dataService.worldPaySessionId = data.SessionId;
            } else {
                this.dataService.worldPaySessionId = '';
            }
        }
    }
}
